import '.b6{height:2rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.b7{justify-content:flex-end;}.ssr-plugin'
import '.au{position:relative;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.a7{cursor:pointer;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.b8{position:sticky;}.ssr-plugin'
import '.b9{top:0px;}.ssr-plugin'
import '.ba{z-index:8;}.ssr-plugin'
import '.bb{background:var(--nav-bg);}.ssr-plugin'
import '.ac{padding:1rem;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { type ReactNode } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { TextLink } from '@app/components/core/link/TextLink'
import { styled, Style } from 'inlines'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { ProfileMenu } from './ProfileMenu'
import { useTranslations } from '@i18n/useLanguage'

export type NavBarMobileProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  logo: ReactNode
  onMenuOpen: () => void
  children: ReactNode
}

const ACCOUNT_SLOT_WIDTH = '6rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

type AccountSectionProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  style?: Style
}

const AccountSection = ({
  userName,
  avatar,
  isLoading,
  style,
}: AccountSectionProps) => {
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common

  if (isLoading) {
    return <div className="b6" style={{ width: ACCOUNT_SLOT_WIDTH,}} />
  }

  return (
    <styled.div className="d b7"
      style={{
        width: ACCOUNT_SLOT_WIDTH,
        animation: ACCOUNT_APPEAR_ANIMATION,
        ...style,
      }}
    >
      {userName ? (
        <ProfileMenu>
          <div className="au d e z a7"
          >
            <Avatar size="extra-small" labelSource={userName} image={avatar} />
          </div>
        </ProfileMenu>
      ) : (
        <Button
          variant="primary"
          label={translations.signUp}
          size="small"
          onClick={() => showAuthModal('signUp')}
        />
      )}
    </styled.div>
  )
}

export const NavBarMobile = ({
  userName,
  avatar,
  isLoading,
  logo,
  onMenuOpen,
  children,
}: NavBarMobileProps) => (
  <div className="n b8 b9 ba bb"
  >
    <nav className="bb n d ac g z"
    >
      <TextLink icon={faBars} onClick={onMenuOpen} />

      <TextLink
        to={pages.home}
        noHover={true}
        isBold={false}
        textStyle={{ display: 'flex', alignItems: 'center' }}
      >
        {logo}
      </TextLink>

      <AccountSection
        style={{ marginLeft: 'auto' }}
        userName={userName}
        avatar={avatar}
        isLoading={isLoading}
      />
    </nav>

    {children}
  </div>
)
